import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const ACCESS_KEY = "yugos_access_token";
const REFRESH_KEY = "yugos_refresh_token";

export const tokenStore = {
    getAccess: () => localStorage.getItem(ACCESS_KEY),
    getRefresh: () => localStorage.getItem(REFRESH_KEY),
    set: (access, refresh) => {
        if (access) localStorage.setItem(ACCESS_KEY, access);
        if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
    },
    clear: () => {
        localStorage.removeItem(ACCESS_KEY);
        localStorage.removeItem(REFRESH_KEY);
    },
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const t = tokenStore.getAccess();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

let refreshing = null;
api.interceptors.response.use(
    (r) => r,
    async (error) => {
        const original = error.config;
        if (
            error.response?.status === 401 &&
            !original._retry &&
            tokenStore.getRefresh() &&
            !original.url?.includes("/auth/")
        ) {
            original._retry = true;
            try {
                refreshing =
                    refreshing ||
                    axios.post(`${API_BASE}/auth/refresh`, {
                        refresh_token: tokenStore.getRefresh(),
                    });
                const { data } = await refreshing;
                refreshing = null;
                tokenStore.set(data.access_token, null);
                original.headers.Authorization = `Bearer ${data.access_token}`;
                return api(original);
            } catch (e) {
                refreshing = null;
                tokenStore.clear();
                window.location.href = "/login";
                return Promise.reject(e);
            }
        }
        return Promise.reject(error);
    },
);

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    if (typeof detail === "object" && detail.msg) return detail.msg;
    return String(detail);
}
